const utils = {
    getFormattedPrice: function(price) {
        return `${(price/100).toFixed(2)}`
    },
    getProductDiscount: function(product) {
        if (!product.compare_at_price) return this.getFormattedPrice(0)
        return this.getFormattedPrice(product.price - product.compare_at_price);
    }
}

dataLayer.push({ ecommerce: null });
dataLayer.push({
  event: "view_item",
  ecommerce: {
    items: [
    {
        item_id: productData.variants[0].sku,
        item_name: productData.title,
        affiliation: Shopify.shop,
        currency: Shopify.currency.active,
        discount: utils.getProductDiscount(productData),
        index: 0,
        item_brand: productData.vendor,
        item_category: productData.type,
        item_list_id: collectionData?.handle || 'all',
        item_list_name: collectionData?.title || 'All',
        item_variant: productData.variants[0].title,
        price: utils.getFormattedPrice(productData.price),
        quantity: 1
    }
    ]
  }
});